export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const DRIVER_ADDED_SUCCESS = "DRIVER_ADDED_SUCCESS";
export const VENDOR_ADDED_SUCCESS = "VENDOR_ADDED_SUCCESS";
export const ADMIN_ADDED_SUCCESS = "ADMIN_ADDED_SUCCESS";
export const GET_ORDERS = "GET_ORDERS";
export const TRACK_ORDER = "TRACK_ORDER";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_STATUS = "USER_STATUS";
export const MEMBER_ROLE = "MEMBER_ROLE";
export const COMPLAINT_DATA = "COMPLAINT_DATA";
export const ASSIGNED_DATA = "ASSIGNED_DATA";
export const CLOSED_COMPLAINT = "CLOSED_COMPLAINT";
export const ADd_COUPON = "ADD_COUPON";
export const GET_SUPPORT = "GET_SUPPORT";
export const DISABLE_MEMBER = "DISABLE_MEMBER";
export const CASH_COLLECTED = 'CASH_COLLECTED'
